(() => {
    class User {
        constructor() {
            this.key        = App.Variable('frontendPublicKey');
            this.loggedIn   = App.Variable('userId') !== '';
            this.sessionId  = App.sessionId;
            this.state      = this.loggedIn;

            this.searchAndReplaceUserTags();
        }

        get Observer() {
            if (!this._observer)
                this._observer = new App.Entities.Observer(this);
            return this._observer;
        }

        get(callback) {
            /* Get actual session */
            App.Endpoint.Session.get = session => {
                // Change "logged in" status
                this.loggedIn = session.session;
                // Notify only if state has change
                if (this.state !== this.loggedIn) {
                    this.state = this.loggedIn;
                    this.Observer.notify();
                }
                if (callback) callback(session);
            };
        }

        isLoggedIn() {
            return this.loggedIn;
        }

        logOut(onSuccess) {
            let Self = this;
            return App.Interface.Api.remove('accounts.sessions', [], {key: this.key}, function(session) {
                Self.loggedIn = false;
                Self.Observer.notify();
                if (onSuccess) onSuccess();
            });
        }

        logIn(email, password, onSuccess = null) {
            App.Interface.Api.post(
                'accounts.sessions',
                {},
                {email: email, password: password},
                {
                    contentType: 'application/json',
                },
                data => {
                    this.loggedIn   = true;
                    this.state      = this.loggedIn;
                    App.sessionId  = data.sessionId;
                    this.Observer.notify();
                    if (onSuccess) onSuccess(data);
                },
                data => {
                    App.Interface.Notification.add('floating', __('ACCOUNT.LOGIN.ERROR_NAME_OR_PW')).update();
                }
            );
        }

        searchAndReplaceUserTags() {
            this.usernames  = [...document.getElementsByTagName('username')];

            for (let username of this.usernames) {
                if (username.closest('section.cms-section')) {
                    username.outerHTML = username.outerHTML.replaceAll('<', '[').replaceAll('>', ']');
                } else if (this.isLoggedIn()) {
                    App.Interface.Utilities.searchAndReplaceTagWithVariable(username);
                }
            }
        }

        update() {
            this.get();
        }
    }
    App.Interface.User = new User();
})();
